import { mapState } from 'vuex';

import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';
import ProductList from '@/components/widgets/ProductList.vue';

// @vue/component
export default {
  name: 'Welcome',
  components: {
    PageHeader,
    Loading,
    ProductList,
  },
  data() {
    return {
      utm_content: '',
    };
  },
  mounted() {
    if (this.$route.query.utm_content) this.utm_content = this.$route.query.utm_content;
    this.$nextTick(() => {
      if (this.products.length === 1) {
        window.location.href = (this.loggedIn ? '/' : '/launchpad/login/') + this.products[0].code;
      }
    });
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.login.loggedIn,
      siteInfo: (state) => state.site.siteInfo,
      productInfo: (state) => state.site.productInfo,
    }),
    title() {
      if (this.siteInfo.displayOptions.showSiteNameOnLoginScreen) {
        return `Welcome to ${this.siteInfo.name}`;
      }
      return 'Welcome';
    },
    subtitle() {
      return 'Select the app you want to start with.<br>Use them together for greater team productivity.';
    },
    products() {
      return this.productInfo
        .filter((v) => this.siteInfo.apps[v.code])
        .map((v) => ({
          ...v,

          url: (this.loggedIn ? '/' : '/launchpad/login/') + (v.code === 'projects' ? 'app' : v.code) + (this.utm_content ? `/?utm_content=${this.utm_content}` : ''),
        }));
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/Welcome/Welcome.js